import { render, staticRenderFns } from "./SlotTemplateSelector.vue?vue&type=template&id=72b127ed&scoped=true&"
import script from "./SlotTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./SlotTemplateSelector.vue?vue&type=script&lang=js&"
import style0 from "./SlotTemplateSelector.vue?vue&type=style&index=0&id=72b127ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b127ed",
  null
  
)

export default component.exports